import { getFieldMapping } from "../../utils/util";
import { intToBool } from "./helpers";
import { AvailabilityService, StockStatus } from "../../services/availabilityService";

const state = {
    netsuiteId: null,
    netsuiteURL: null,
    stockCode: null,
    apiData: null,
    isDealer: false,
    isSiteB2C: false,
    isSiteB2B: false,
    isCustomB2cEnabled: false,
    isSparePartEnabled: false,
    isPackageWithoutComponents: false,
    cartUrlParams: "",
    componentsStockAvailabilityAU: null,
    auStockValue: 0,
};
const mutations = {
    setApiData(state, data) {
        state.apiData = data;
    },
    setNetsuiteId(state, netsuiteId) {
        state.netsuiteId = netsuiteId;
    },
    setStockCode(state, stockCode) {
        state.stockCode = stockCode;
    },
    setNetsuiteURL(state, url) {
        state.netsuiteURL = url;
    },
    checkB2B(state, status) {
        state.isSiteB2B = intToBool(status);
    },
    checkB2C(state, status) {
        state.isSiteB2C = intToBool(status);
    },
    checkDealerUser(state, status) {
        state.isDealer = intToBool(status);
    },
    checkSparePartsSettings(state, status) {
        state.isSparePartEnabled = intToBool(status);
    },
    checkCustomB2C(state, status) {
        state.isCustomB2cEnabled = intToBool(status);
    },
    checkRegionStock(state, status) {
        state.hasRegionStock = !intToBool(status);
    },
    checkPackageWithoutComponents(state, status) {
        state.isPackageWithoutComponents = intToBool(status);
    },
    setCartUrlParams(state, params) {
        state.cartUrlParams = params;
    },
    setComponentsStockAvailabilityAU(state, params) {
        state.componentsStockAvailabilityAU = params;
    }
};


const actions = {};
const getters = {
    isAddToCartButtonVisible:(state,getters,rootState,rootGetters) =>(  standaloneData = null,
        parentNetsuiteId = null,
        isAlwaysInStock = null) =>{
        console.log("isAddToCartButtonVisible:", standaloneData, parentNetsuiteId, isAlwaysInStock);
        const components = standaloneData ?? getters.components;
        const parentProduct = standaloneData
            ? getters.parentProduct(components, parentNetsuiteId)
            : getters.parentProduct();
        const isPackageWithoutComponents = standaloneData
            ? intToBool(isAlwaysInStock)
            : state.isPackageWithoutComponents;
        const {isSiteB2B, isDealer} = state;

        //check if user has no cart access
        if (getters.noCartAccess){
            console.log("AddToCart: no cart access");
            return false;
        }

        if(!parentProduct){
            console.log("AddToCart: no parent product");
            return false;
        }

        // Get user type for availability checks
        const userType = rootGetters["auth/userType"] || "B2C";
        const isB2BDealer = isSiteB2B && isDealer;

        let availabilityStatus = StockStatus.IN_STOCK;
        if (components.length > 1) {
            components.forEach(component => {
                if (component.itemtype !== "NonInvtPart") {
                    const newAvailabilityStatus = AvailabilityService.getStockStatus(
                        component,
                        userType,
                        window.culture
                    );
                    if (newAvailabilityStatus === StockStatus.NOT_AVAILABLE) {
                        availabilityStatus = StockStatus.NOT_AVAILABLE;
                    }
                }
            });
            console.log("AddToCart: availability status:", availabilityStatus);
            return availabilityStatus !== StockStatus.NOT_AVAILABLE;

        } else {
            // Check if product is actually available for sale using AvailabilityService
            availabilityStatus = AvailabilityService.getStockStatus(
                parentProduct,
                userType,
                window.culture
            );

            // Hide button if product is not available for sale
            if (availabilityStatus === StockStatus.NOT_AVAILABLE) {
                console.log("AddToCart: not available");
                return false;
            }
        }

        // If spare parts enabled and item is spare parts
        if (
            state.isSparePartEnabled &&
            parentProduct.custitem_onlinesparepart
        ) {
            // For spare parts, only show if in stock
            console.log("AddToCart: spare parts");
            return availabilityStatus === StockStatus.IN_STOCK;
        }

        // --- Package products ---
        if (components.length > 1) {
            // Use AvailabilityService to check package stock
            const packageInStock = AvailabilityService.isPackageInStock(components);
            if (packageInStock) {
                console.log("AddToCart: package in stock");
                return true;
            }

            // B2B dealers can backorder packages
            if (isB2BDealer) {
                const packageBackOrderable = AvailabilityService.isPackageBackOrderable(components);
                // Check if parent product allows backorder (already checked in availabilityStatus)
                if (packageBackOrderable && availabilityStatus !== StockStatus.OUT_OF_STOCK) {
                    console.log("AddToCart: package backorderable");
                    return true;
                }
            }

            return false;
        }

        // --- RV package (always in stock) ---
        if (isPackageWithoutComponents) {
            console.log("AddToCart: package without components");
            return true;
        }

        // --- Single product ---
        // Use availability status from AvailabilityService
        if (availabilityStatus === StockStatus.IN_STOCK) {
            console.log("AddToCart: in stock");
            return true;
        }

        // B2B dealers can backorder
        if (isB2BDealer && availabilityStatus === StockStatus.BACKORDER) {
            console.log("AddToCart: backorder");
            return true;
        }

        return false;
    },
    components: state => {
        return state.apiData ? state.apiData.items : null;
    },
    parentProduct: (state, getters) => (
        standaloneComponents = null,
        parentNetsuiteId = null
    ) => {
        const components = standaloneComponents ?? getters.components;
        const netsuiteId = parentNetsuiteId ?? state.netsuiteId;

        if (!components || components.length === 0) {
            return null;
        }

        // Single component - return it
        if (components.length === 1) {
            return components[0];
        }

        // Multiple components - find the main one by netsuiteId
        return components.find(item => item.internalid === netsuiteId) || null;
    },
    isPackageInStock: (state, getters) => (standaloneComponents = null) => {
        const components = standaloneComponents ?? getters.components;
        return AvailabilityService.isPackageInStock(components);
    },
    isPackageBackOrderable: (state, getters) => (
        standaloneComponents = null
    ) => {
        const components = standaloneComponents ?? getters.components;
        return AvailabilityService.isPackageBackOrderable(components);
    },
    hasRegionStock: (state, getters) => parentProduct => {
        // Region stock check is handled by AvailabilityService.isItemNotForSale()
        // This getter always returns true as region checks are done elsewhere
        return true;
    },
    getComponentByStockCode: (state, getters) => stockCode => {
        if (!getters.components || !stockCode) {
            return null;
        }

        // First try exact match
        const exactMatch = getters.components.find(item => item.itemid === stockCode);
        if (exactMatch) {
            return exactMatch;
        }

        // Fallback to prefix match (for variants)
        return getters.components.find(item => item.itemid.startsWith(stockCode)) || null;
    },
    noCartAccess(state, getters, rootState, rootGetters) {
        return rootGetters["auth/cartNoAccess"];
    },
    getCartUrlParams(state, getter) {
        return state.cartUrlParams;
    },
    getStockAvailabilityAU: (state) => netsuiteId => {
        if (!state.componentsStockAvailabilityAU || !netsuiteId) {
            return null;
        }

        for (const component of state.componentsStockAvailabilityAU) {
            const [componentNetsuiteId, componentData] = component;
            if (componentNetsuiteId === netsuiteId) {
                return componentData.stockStatus;
            }
        }

        return null;
    }
};


const cart = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

export default cart;
